module.exports = __webpack_public_path__ + "8ef4f52ac138561d7f1f259adcdc7fca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-3.png
// module id = 2203
// module chunks = 0